import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class CategoryMoveAction {
    constructor(public sourceCategoryId: number, public targetCategoryId: number) {
    }
}

/**
 * Action Service to move a category to another parent category
 */
@Injectable()
export class CategoryMoveService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "category-move");
    }
}
